/**
 * @flow
 * */

import styled from 'react-emotion'
import ResponsiveContainer from '../../core/ResponsiveContainer'
import { Type16VeryLightPinkDR } from '../../../themes/Fonts/Din2014'
import { mobile, tablet } from '../../../utils/mixins'
import Colors from '../../../themes/Colors'
import { SectionHeading } from '../styedComponents'

export const AdvisoryCouncilContainer = styled(ResponsiveContainer)`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const Title = styled(SectionHeading)`
  margin-bottom: 24px;
  margin-top: 0;
`

export const Description = styled(Type16VeryLightPinkDR)`
  color: ${Colors.darkGreyBlue};
  text-align: center;
  width: 100%;
  margin-top: 10px;
  margin-bottom: 40px;
  ${mobile} {
    margin-top: 30px;
    margin-bottom: 30px;
    font-size: 14px;
  }
`

export const CouncilMembersContainer = styled('div')`
  display: flex;
  justify-content: space-around;
  width: 100%;
  margin-top: 40px;
  ${mobile} {
    flex-direction: column;
    align-items: center;
  }
  ${tablet} {
    width: 100%;
  }
`



// WEBPACK FOOTER //
// ./src/components/TeamNew/AdvisoryCouncilSection/styledComponents.js